import { getQuery, insertQuery, updateQuery, deleteQuery } from "api/UdasWrapper";
import { addErrorLog } from "../Logger/logger";
import { uncompressRows } from "helpers/common";
import { cacheUpdateSocketIoClient } from "../App";

export const getFlowVersionsByFlowId = async (flow_id) => {
   try {
      const data = JSON.stringify({
         query: `query GetFlowVersionsByFlowId($flowId: ID!) {
  getFlowVersionsByFlowId(flow_id: $flowId) {
    isSuccessful
    message
    resultObject
  }
}`,
         variables: {
            flowId: flow_id
         }
      });
      const result = (await getQuery(data))?.getFlowVersionsByFlowId;

      uncompressRows(result?.resultObject);

      return result;
   } catch (error) {
      addErrorLog("query GetFlowVersionsByFlowId", error);
      return null;
   }
};

export const updateFlowVersion = async (input) => {
   if (cacheUpdateSocketIoClient?.connected) {
      cacheUpdateSocketIoClient.emit("flowUpdate", { tenantId: input.tenant_id, flowId: input.flow_id, flowName: input.name });
   } else {
      console.error('Unable to request flow cache update in cxf-executor because the service is not running or not reachable');
      return null;
   }

   try {
      const data = JSON.stringify({
         query: `mutation UpdateFlowVersionById($input: FlowVersionsInput, $updateStatus: Boolean) {
  updateFlowVersionById(input: $input, update_status: $updateStatus) {
    isSuccessful
    message
    resultObject
  }
}`,
         variables: {
            input: {
               tenant_id: input.tenant_id,
               flow_id: input.flow_id,
               name: input.name,
               version: input.version,
               steps: input.steps,
               status: input.status,
               tags: input.tags
            },
            updateStatus: input.set_status
         }
      });

      return (await updateQuery(data))?.updateFlowVersionById;
   } catch (error) {
      addErrorLog("mutation UpdateFlowVersionById", error, input.tenant_id);
      return null;
   }
};

export const insertFlowVersion = async (tenant_id, flow_id, flowName, version_type) => {
   if (cacheUpdateSocketIoClient?.connected) {
      cacheUpdateSocketIoClient.emit("flowUpdate", { tenantId: tenant_id, flowId: flow_id, flowName });
   } else {
      console.error('Unable to request flow cache update in cxf-executor because the service is not running or not reachable');
      return null;
   }

   try {
      const data = JSON.stringify({
         query: `mutation InsertFlowVersion($tenantId: String!, $flowId: ID!, $versionType: String!) {
  insertFlowVersion(tenant_id: $tenantId, flow_id: $flowId, version_type: $versionType) {
    isSuccessful
    message
    resultObject
  }
}`,
         variables: {
            tenantId: tenant_id,
            flowId: flow_id,
            versionType: version_type
         }
      });
      return (await insertQuery(data))?.insertFlowVersion;
   } catch (error) {
      addErrorLog("mutation InsertFlowVersion", error, tenant_id);
      return null;
   }
};

export const deleteFlowVersion = async (flow_id, version, tenant_id) => {
   try {
      const data = JSON.stringify({
         query: `mutation DeleteFlowVersionById($flow_id: ID!, $version: String!, $tenant_id: String!) {
  deleteFlowVersionById(flow_id: $flow_id, version: $version, tenant_id: $tenant_id) {
    isSuccessful
    message
    resultObject
  }
}`,
         variables: {
            flow_id,
            version,
            tenant_id
         }
      });
      return (await deleteQuery(data))?.deleteFlowVersionById;
   } catch (error) {
      addErrorLog("mutation DeleteFlowVersionById", error, tenant_id);
      return null;
   }
};

export const changeFlowMode = async (tenant_id, flow_id, mode) => {
   try {
      const data = JSON.stringify({
         query: `mutation ChangeFlowMode($input: ChangeFlowModeInput) {
  changeFlowMode(input: $input) {
    isSuccessful
    message
    resultObject
  }
}`,
         variables: {
            input: {
               tenant_id: tenant_id,
               flow_id: flow_id,
               mode: mode
            }
         }
      });
      return (await updateQuery(data))?.changeFlowMode;
   } catch (error) {
      addErrorLog("mutation ChangeFlowMode", error, tenant_id);
      return null;
   }
};

export const setFlowVersion = async (input) => {
   if (cacheUpdateSocketIoClient?.connected) {
      cacheUpdateSocketIoClient.emit("flowUpdate", { tenantId: input.tenant_id, flowId: input.flow_id, flowName: input.name });
   } else {
      console.error('Unable to request flow cache update in cxf-executor because the service is not running or not reachable');
      return null;
   }

   try {
      const data = JSON.stringify({
         query: `mutation SetFlowVersion($input: SetFlowVersionInput) {
  setFlowVersion(input: $input) {
    isSuccessful
    message
    resultObject
  }
}`,
         variables: { input }
      });
      return (await updateQuery(data))?.setFlowVersion;
   } catch (error) {
      addErrorLog("mutation SetFlowVersion", error);
      return null;
   }
};

export const changeFlowVersion = async (tenant_id, flow_id, flowName, version_id) => {
   if (cacheUpdateSocketIoClient?.connected) {
      cacheUpdateSocketIoClient.emit("flowUpdate", { tenantId: tenant_id, flowId: flow_id, flowName });
   } else {
      console.error('Unable to request flow cache update in cxf-executor because the service is not running or not reachable');
      return null;
   }

   try {
      const data = JSON.stringify({
         query: `mutation ChangeFlowVersion($tenantId: String!, $flowId: ID!, $versionId: String!) {
  changeFlowVersion(tenant_id: $tenantId, flow_id: $flowId, version_id: $versionId) {
    isSuccessful
    message
    resultObject
  }
}`,
         variables: {
            tenantId: tenant_id,
            flowId: flow_id,
            versionId: version_id
         }
      });
      const result = (await updateQuery(data))?.changeFlowVersion;

      uncompressRows(result?.resultObject);

      return result;
   } catch (error) {
      addErrorLog("mutation ChangeFlowVersion", error);
      return null;
   }
};

export const getFlowVersionById = async (flow_id, version) => {
   try {
      const data = JSON.stringify({
         query: `query GetFlowVersionById($flow_id: ID!, $version: String!) {
  getFlowVersionById(flow_id: $flow_id, version: $version) {
    isSuccessful
    message
    resultObject
  }
}`,
         variables: {
            flow_id,
            version
         }
      });
      const result = (await getQuery(data))?.getFlowVersionById;

      uncompressRows(result);

      return result;
   } catch (error) {
      addErrorLog("query GetFlowVersionById", error);
      return null;
   }
};
